module.exports = __webpack_public_path__ + "static/img/India-s-botanical-supplier-firm-addresses-pesticides-traceability-challenges.f460b9b6.png";